<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import useHotWords from '../../../composable/content/useHotWords'
import { useI18n } from 'vue-i18n'
import _ from "lodash";

const {t} = useI18n()
const {raw,result,fetch,addHotWords,removeHotWords,isShowBtn,save,isLoading,hotWords,updateHotWords} = useHotWords()
const confirmDialog = ref(false)

//mounted
onMounted(() => {
  fetch()
})

//methods
const update = () => {
  confirmDialog.value = false
  save()
}

const handleClose = () => {
  confirmDialog.value = false
  isShowBtn.value = false
  hotWords.value = ''
  raw.value = _.cloneDeep(result.value)
}
</script>


<template>
  <VCard class="hot-search-words" >
    <div class="hot-search-words-title">
      <h3>{{t('text-hot-words-name')}}</h3>
      <i class="iconfont icon-hot-word" style="color: var(--red);"  aria-hidden="true"></i>
    </div>
    <VControl expanded icon="feather:edit-3">
      <input type="text" class="input" v-model="hotWords" :disabled="isLoading" :placeholder="'输入热搜词，回车后批量添加'" @keyup.enter="addHotWords"/>
    </VControl>
    <V-Loader size="small" :active="isLoading" class="hot-search-words-tags">
      <VTags class="hot-search-words-tags-item" addons v-for="(item,index) in raw" :key="index">
        <VTag
          :label="item.title"
          color="primary"
          style="cursor: pointer"
        />
        <VTag
          remove
          style="cursor: pointer"
          @click.prevent="removeHotWords(index)"
        />
      </VTags>
    </V-Loader>
    <V-Button v-if="isShowBtn" color="primary" rounded elevated @click="confirmDialog = true"> 保存 </V-Button>
  </VCard>
  <V-Modal
    :open="confirmDialog"
    :title="t('title-dialog-update-hot-words')"
    actions="center"
    size="small"
    @close="handleClose"
  >
    <template #content>
      <div>是否确认更新热搜词为：</div>
      <div class="name">{{updateHotWords}}</div>
    </template>
    <template #action>
      <V-Button
        v-t="'action-confirm'"
        color="primary"
        raised
        :loading="isLoading"
        @click="update"
      ></V-Button>
    </template>
  </V-Modal>
</template>

<style lang="scss">
.hot-search-words {
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 {
      font-weight: 600;
    }
    .icon-hot-word {
      font-size: 25px;
    }
  }
  .input {
    margin-bottom: 20px;
    font-size: 8px; 
  }
  &-tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    &-item {
      margin-left: 10px;
      margin-bottom: 1rem !important;
    }
  }
}
.modal-card-body {
  .inner-content {
    .name {
      margin-top: 10px;
      font-weight: 600;
    }
  }
}
</style>